import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { db } from '../../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { BookOpen, Loader2 } from 'lucide-react';
import CourseCard from '../../components/dashboard/CourseCard';

export default function InstructorCourses() {
  const { currentUser } = useAuth();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const coursesQ = query(collection(db, 'courses'), where('instructorId', '==', currentUser.uid));
        const coursesSnap = await getDocs(coursesQ);
        setCourses(coursesSnap.docs.map(d => ({ id: d.id, ...d.data() })));
      } catch (err) {
        console.error("Error fetching instructor courses:", err);
      } finally {
        setLoading(false);
      }
    };
    if (currentUser) fetchCourses();
  }, [currentUser]);

  if (loading) {
    return (
      <div className="flex items-center justify-center p-20">
        <Loader2 className="w-8 h-8 animate-spin text-amber-500" />
      </div>
    );
  }

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-700">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-black text-slate-900 dark:text-white tracking-tight">إدارة دوراتك</h1>
      </div>

      {courses.length === 0 ? (
        <div className="bg-slate-50 dark:bg-zinc-900 border border-slate-200 dark:border-white/10 rounded-3xl p-16 text-center">
          <BookOpen className="w-16 h-16 text-slate-300 dark:text-zinc-700 mx-auto mb-4" />
          <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-2">لا توجد دورات حتى الآن</h3>
          <p className="text-slate-500 dark:text-zinc-400 font-medium text-lg">لم تقم بإضافة أي دورات. تواصل مع الإدارة لطلب الصلاحية.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {courses.map(course => (
            <CourseCard key={course.id} course={course} isEnrolled={false} isPublicView={true} />
          ))}
        </div>
      )}
    </div>
  );
}
